import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
import {
  GETCUSTOM_TAG_FUNCIONALIDADE,
  TagFuncionalidadeListState,
} from "../../../../ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";
export const GET_AGENDAMENTOS = "[AGENDAMENTO APP] GET AGENDAMENTOS";
export const GET_AGENDAMENTO = "[AGENDAMENTO APP] GET AGENDAMENTO";
export const AGENDAMENTO_ERROR = "[AGENDAMENTO APP] AGENDAMENTO ERROR";
export const AGENDAMENTO_WARNING = "[AGENDAMENTO APP] AGENDAMENTO WARNING";
export const AGENDAMENTO_INFO = "[AGENDAMENTO APP] AGENDAMENTO INFO";
export const GET_PROFISSIONAISEMPRESA =
  "[AGENDAMENTO APP] GET PROFISSIONAIS EMPRESA";
export const GET_PRODUTOSEMPRESA = "[AGENDAMENTO APP] GET PRODUTOS EMPRESA";
export const GET_ESPECIALIDADESEMPRESA =
  "[AGENDAMENTO APP] GET ESPECIALIDADES EMPRESA";
export const GET_LOCAISEMPRESA = "[AGENDAMENTO APP] GET LOCAIS EMPRESA";
export const GET_AGENDAMENTO_PESSOA =
  "[AGENDAMENTO APP] GET AGENDAMENTO PESSOA";
export const AGENDAMENTO_ADD_TEMPORARIO =
  "[AGENDAMENTO APP] AGENDAMENTO ADD TEMPORARIO";

const AgendamentoListState = [
  "idagendamento",
  "responsaveis",
  "clientes",
  "idpessoaformulariolocal",
  "titulo",
  "anotacoes",
  "tipo",
  "inicio",
  "iniciodescricao",
  "termino",
  "terminodescricao",
  "agendamentotag",
  "preatendimento",
  "duracao",
  "periodo",
];

const ProfissionalGetState = ["idpessoaformulario", "nome", "jornada"];

const EmpresaProdutoGetState = ["idpessoaformulario", "nomevalor", "nome"];

const EmpresaEspecialidadeGetState = ["idpessoaformulario", "nome"];

const EmpresaLocalGetState = ["idpessoaformulario", "nome"];

export function list(_AAction, _AParams, _AFilter = null, _AParametros) {
  return (dispatch) => {
    var AConditionsAND = [];
    var AConditionsOR = [];
    var AActions = [];

    if (_AFilter !== null) {
      if (_AFilter.AND && _AFilter.AND !== null) {
        AConditionsAND = _AFilter.AND;
      }

      if (_AFilter.OR && _AFilter.OR !== null) {
        AConditionsOR = _AFilter.OR;
      }
    }

    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      _AParametros.nome,
      AActions,
      _AParametros.procedure,
      AgendamentoListState,
      _AAction,
      AConditionsAND,
      AConditionsOR
    );

    AConditionsAND = [
      { Campo: "tagfuncionalidade.tipo", Operador: "=", Valor: "agendamento" },
    ];
    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "tagfuncionalidade",
      AActions,
      "spvwtagfuncionalidade",
      TagFuncionalidadeListState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    AConditionsAND = [
      { Campo: "tagfuncionalidade.tipo", Operador: "=", Valor: "atendimento" },
    ];
    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "tagfuncionalidade",
      AActions,
      "spvwtagfuncionalidade",
      TagFuncionalidadeListState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    AConditionsAND = [
      { Campo: "tagfuncionalidade.tipo", Operador: "=", Valor: "pessoa" },
    ];
    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "tagfuncionalidade",
      AActions,
      "spvwtagfuncionalidade",
      TagFuncionalidadeListState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    XAPPService.XappSelAction(AActions, _AParams)
      .then((response) =>
        Promise.all([
          dispatch({
            type: GET_AGENDAMENTOS,
            Name:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[0].name
                : "",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[0].data
                : "",
          }),
          dispatch({
            type: GETCUSTOM_TAG_FUNCIONALIDADE,
            Name: "agendamento",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[1].data
                : "",
          }),
          dispatch({
            type: GETCUSTOM_TAG_FUNCIONALIDADE,
            Name: "atendimento",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[2].data
                : "",
          }),
          dispatch({
            type: GETCUSTOM_TAG_FUNCIONALIDADE,
            Name: "pessoa",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[3].data
                : "",
          }),
        ])
      )
      .catch((error) => {
        return dispatch({
          type: AGENDAMENTO_ERROR,
          payload: error,
        });
      });
  };
}

export function clearAgendamentos() {
  return {
    type: GET_AGENDAMENTOS,
    payload: null,
    removeTemporario: true,
  };
}

export function getBaseFiltro(_AParams) {
  return (dispatch) => {
    var AActions = [];
    var AConditionsOR = [];
    var AConditionsAND = [
      { Campo: "pessoaformulario.statusregistro", Operador: "=", Valor: 1 },
    ];

    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "ProfissionaisEmpresa",
      AActions,
      "spvwempresapessoafuncionarioatendimento",
      ProfissionalGetState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "ProdutosEmpresa",
      AActions,
      "spvwempresaproduto",
      EmpresaProdutoGetState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "EspecialidadesEmpresa",
      AActions,
      "spvwempresaproduto",
      EmpresaEspecialidadeGetState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    AActions = XAPPService.XappSelActionFactory(
      _AParams.empresa,
      "LocaisEmpresa",
      AActions,
      "spvwempresalocal",
      EmpresaLocalGetState,
      "SELECIONAR",
      AConditionsAND,
      AConditionsOR
    );

    XAPPService.XappSelAction(AActions, _AParams, "SEL")
      .then((response) =>
        Promise.all([
          dispatch({
            type: GET_PROFISSIONAISEMPRESA,
            Name:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[0].name
                : "",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[0].data
                : "",
          }),
          dispatch({
            type: GET_PRODUTOSEMPRESA,
            Name:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[1].name
                : "",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[1].data
                : "",
          }),
          dispatch({
            type: GET_ESPECIALIDADESEMPRESA,
            Name:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[2].name
                : "",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[2].data
                : "",
          }),
          dispatch({
            type: GET_LOCAISEMPRESA,
            Name:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[3].name
                : "",
            payload:
              response.data && response.data.length > 0
                ? JSON.parse(response.data)[3].data
                : "",
          }),
        ])
      )
      .catch((error) => {
        return dispatch({
          type: AGENDAMENTO_ERROR,
          payload: error,
        });
      });
  };
}

export function save(_AValue, _AParams, _AAction, _ACallback = null) {
  return (dispatch) => {
    var AConditionsAND = [];
    var AConditionsOR = [];
    var AActions = [];

    let ATmpValue = Object.assign({}, _AValue);
    if (!_.isUndefined(_AValue.status) && !_.isNull(_AValue.status)) {
      ATmpValue.status = _AValue.status.id;
    }

    if (!_.isUndefined(_AValue.data) && !_.isNull(_AValue.data)) {
      ATmpValue.inicio = _AValue.data + " " + _AValue.inicio;
      ATmpValue.termino = _AValue.data + " " + _AValue.termino;
    }

    ATmpValue.clientesLookup = null;
    ATmpValue.responsaveisLookup = null;

    AActions = XAPPService.XappCustomActionFactory(
      _AParams.empresa,
      AActions,
      "",
      _AAction,
      ATmpValue,
      "",
      AConditionsAND,
      AConditionsOR
    );

    if (_AAction === "ALTERARSTATUS") {
      let AAction = "";
      if (
        _AValue.status.iniciarprocesso &&
        _.isNull(_AValue.idtarefaprocesso)
      ) {
        AAction = "INICIARFLUXO";
      }
      if (
        _AValue.status.cancelarprocesso &&
        !_.isNull(_AValue.idtarefaprocesso)
      ) {
        AAction = "CANCELARFLUXO";
      }
      if (AAction.length > 1) {
        AActions = XAPPService.XappCustomActionFactory(
          _AParams.empresa,
          AActions,
          "",
          AAction,
          ATmpValue,
          "",
          AConditionsAND,
          AConditionsOR
        );
      }
    }

    XAPPService.XappCustomAction(
      AActions,
      _AParams,
      "spdoactionagendamento",
      "CUSTOM"
    )
      .then((response) => {
        if (response.warning) {
          Promise.all([
            dispatch({
              type: AGENDAMENTO_WARNING,
              payload: response.warning,
            }),
          ]).then(() => {
            if (!_.isNull(_ACallback)) {
              _ACallback();
            }
          });
        } else if (response.info) {
          Promise.all([
            dispatch({
              type: AGENDAMENTO_INFO,
              payload: response.info,
              id: response.ultimoidinserido,
            }),
          ]).then(() => {
            if (!_.isNull(_ACallback)) {
              _ACallback();
            }
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: AGENDAMENTO_ERROR,
          payload: error,
        });
      });
  };
}

export function addAgendamentoTemporario(_AValue) {
  return {
    type: AGENDAMENTO_ADD_TEMPORARIO,
    payload: _AValue,
  };
}
